import { TPlanType } from '../interface/TPlanType'

export const SET_SUBSCRIPTION_PLAN = 'SET_SUBSCRIPTION_PLAN'

interface ISetSubscription {
  type: typeof SET_SUBSCRIPTION_PLAN
  payload: {
    planName: TPlanType
    price: number
  }
}

export type TActionTypes = ISetSubscription
